import { useState, useEffect } from "react";
import { getTournamentDetails } from "../services/tournamentService";
import { useNavContext } from "../context/nav_context";
import { current_tournament } from "../utils/constants";

const useTournamentDetails = (tournamentId) => {
  const { accessToken } = useNavContext();
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const id = tournamentId || current_tournament;
    if (!id) return;

    let cancelled = false;

    const loadDetails = async () => {
      try {
        setLoading(true);
        setError(false);
        const data = await getTournamentDetails(id, accessToken);
        if (!cancelled) {
          setDetails(data);
        }
      } catch {
        if (!cancelled) setError(true);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    loadDetails();

    return () => {
      cancelled = true;
    };
  }, [tournamentId, accessToken]);

  return { details, loading, error };
};

export default useTournamentDetails;
